import { useStore } from "@state/store"
import { useEffect } from "react"
import styled from "styled-components/macro"
import { useProjectDataStore } from "@state/projectDataStore"
import First from "./components/First"
import Second from "./components/Second"

const Info2 = (props: any) => {
  const contentControls = useStore((s) => s.contentControls)
  const syncState = useStore((s) => s.syncState)

  useEffect(() => {
    syncState({
      categoriesVisible: true,
      contentControls: {
        index: 0,
      },
    })
  }, [])

  const info2Data = {
    sections: [
      {
        title: "Community",
        block: [
          {
            headline: "Future Homes standards",
            body: "Each home will be built in accordance with the Future Homes Standard and will take into account upcoming changes to building regulations, through the use of sustainable technologies like air source heat pumps and solar panels. 10% wheelchair adapted home. One in ten of the homes are wheelchair adapted, and all meet or exceed the Nationally Described Space Standards.",
            img: "/assets/imgs/story/1.webp",
          },
          {
            headline: "Integrated green spaces",
            body: "Extensive landscaping will make for a thriving, green neighbourhood, perfectly complementing a newly revitalised and re-energised Woolwich. 454 trees planted",
            img: "/assets/imgs/story/2.webp",
          },
        ],
      },
      {
        title: "Lovell Homes",
        block: [
          {
            headline: "Trusted to transform communities since 1971",
            body: "Lovell has been building homes across the UK for over 50 years. We’ve built thousands of high-quality, innovatively designed apartments, townhouses and family homes, creating welcoming communities where people want to live.",
            img: "/assets/imgs/story/3.webp",
          },
          {
            headline: "SQV Our quality promise",
            body: "At Lovell we believe your home should be more than about the right place at the right price. It should also reflect your personality and tastes. That’s why every Lovell home has Style, Quality and Value (or SQV, as we call it) built-in from the start, making your new home somewhere you’ll be proud to call your own.",
            img: "/assets/imgs/story/4.webp",
          },
        ],
      },
    ],
  }

  return (
    <Info1Wrapper>
      <First info2Data={info2Data?.sections[0]} />
      <Second info2Data={info2Data?.sections[1]} />
    </Info1Wrapper>
  )
}

export default Info2

const Info1Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: var(--secondary);
  display: flex;
`

const Step = styled.div``
